import React from 'react';
import MarketStateFilterInput from '@app/model/market_state/input/MarketStateFilterInput';
import { useSelectedCompanyHotel } from '@app/site/secured/rateshopper/rates/provider/useSelectedCompanyHotel';
import CompetitorTag from '@app/model/company_hotel/CompetitorTag';
import MenuButtonFilter, { MenuButtonFilterItem } from '@app/component/menu/MenuButtonFilter';
import SecuredFragment from '@app/component/security/SecuredFragment';
import Authority from '@app/model/authentication/Authority';
import FormButton from '@app/component/form/button/FormButton';
import ACLAuthority from '@app/model/profile/ACLAuthority';
import {
	useMarketStateFilterInputTools
} from '@app/site/secured/rateshopper/rates/provider/useMarketStateFilterInputTools';
import CompanyHotelDashboardFilter from '@app/model/company_hotel/settings/CompanyHotelDashboardFilter';
import _isEmpty from 'lodash/isEmpty';


const DashboardSelectCompetitorTagsFilter: React.FunctionComponent<{
  filter: MarketStateFilterInput,
  onFilter: (filter: MarketStateFilterInput) => void
}> = ({ filter, onFilter }) => {

  const { companyHotel } = useSelectedCompanyHotel();

  if (!!companyHotel) {
    return <DashboardSelectCompetitorTagsFilterInner tags={companyHotel.getCompetitorTags()}
      filter={filter}
      onFilter={onFilter} />;
  }
  return <></>;

};

type DashboardSelectCompetitorTagsFilterProps = {
  tags: CompetitorTag[],
  filter: MarketStateFilterInput,
  onFilter: (filter: MarketStateFilterInput) => void
}

const DashboardSelectCompetitorTagsFilterInner = React.memo(
  function DashboardSelectCompetitorTagsFilter({ tags = [], filter, onFilter }: DashboardSelectCompetitorTagsFilterProps) {
		const {isDashboardFilterEnabled} = useMarketStateFilterInputTools()
		const providerSupportsFilter = isDashboardFilterEnabled(CompanyHotelDashboardFilter.COMPETITOR_TAGS);

		const menuItems: MenuButtonFilterItem<number>[] = tags.map((tag) => ({
      value: tag.id,
      name: tag.name,
      icon: <span className="inline-block w-2.5 h-2.5 rounded-full" style={{ backgroundColor: tag.color }} />
    }));

    return <MenuButtonFilter
      menuItems={menuItems}
      enableMultiSelect={true}
      selectedValues={filter.competitorTagIds}
      onMultiSelect={(values) => onFilter({ ...filter, competitorTagIds: values })}
      multiSelectDisplayText={(selected) =>
        selected.length === 0 ? 'Any Competitor' :
          selected.length > 1 ? `${selected.length} Groups` :
            selected[0].name
      }
      menuDescription="Please select the competitor group(s)"
      enableSearch={tags.length > 10}
      searchPlaceholder="Filter groups"
			menuWidth="w-64"
			disabled={!providerSupportsFilter}
      footer={
        <SecuredFragment hasAnyAuthority={[Authority.ADMIN, Authority.USER]} hasAclAuthority={ACLAuthority.WRITE}>
          <FormButton state="primary" isLink to="/secured/rateshopper/rates/settings/competitor-groups" extraClassName="py-1.5 w-full">
            Edit Competitor Groups
          </FormButton>
        </SecuredFragment>
      }
    />;
  },);


export default DashboardSelectCompetitorTagsFilter;
